export const downloadCSV = (leads) => {
  const headers = [
    "ID",
    "Data/Ora",
    "Targa",
    "Cellulare",
    "Indirizzo Completo",
    "Via",
    "Civico",
    "CAP",
    "Città",
    "Provincia",
    "Email",
    "Tipo Richiesta",
    "Garanzie",
    "Privacy",
    "Source",
  ];

  const rows = leads.map((lead) => [
    lead.id,
    lead.timestamp,
    lead.plate,
    lead.phone,
    `"${lead.address_components.full_address.replace(/"/g, '""')}"`, // Escape quotes
    lead.address_components.street || "",
    lead.address_components.street_number || "",
    lead.address_components.zip_code || "",
    lead.address_components.city || "",
    lead.address_components.province || "",
    lead.email,
    lead.request_type,
    `"${lead.guarantees.join(", ")}"`,
    lead.privacy_accepted ? "SI" : "NO",
    lead.source_qr,
  ]);

  const csvContent = [
    headers.join(","),
    ...rows.map((row) => row.join(",")),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", "rca_richieste_preventivo.csv");
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
